// ADD DATA
export const ADD_DATA_REQUEST = "ADD_DATA_REQUEST"
export const ADD_DATA_SUCESS = "ADD_DATA_SUCESS"
export const ADD_DATA_FAIL = "ADD_DATA_FAIL"


export const GET_MYDATA_REQUEST = "GET_MYDATA_REQUEST"
export const GET_MYDATA_SUCESS = "GET_MYDATA_SUCESS"
export const GET_MYDATA_FAIL = "GET_MYDATA_FAIL"


export const DELETE_MYDATA_REQUEST = "DELETE_MYDATA_REQUEST"
export const DELETE_MYDATA_SUCESS = "DELETE_MYDATA_SUCESS"
export const DELETE_MYDATA_FAIL = "DELETE_MYDATA_FAIL"


export const UPDATE_MYDATA_REQUEST = "UPDATE_MYDATA_REQUEST"
export const UPDATE_MYDATA_SUCESS = "UPDATE_MYDATA_SUCESS"
export const UPDATE_MYDATA_FAIL = "UPDATE_MYDATA_FAIL"